import _taggedTemplateLiteral from "/home/vsts/work/1/s/Office.Planner.Website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          flex-direction: column;\n\n          & > * + * {\n            margin-top: 0.5rem;\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          align-items: center;\n          flex-wrap: wrap;\n          margin: -0.5rem -0.75rem;\n\n          & > * {\n            padding: 0.5rem 0.75rem;\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
var StyledRadioGroup = styled.div(_templateObject(), function (props) {
  return props.horizontal ? css(_templateObject2()) : css(_templateObject3());
});

function CheckboxGroup(_a) {
  var children = _a.children,
      _a$direction = _a.direction,
      direction = _a$direction === void 0 ? 'horizontal' : _a$direction,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      rest = __rest(_a, ["children", "direction", "className"]);

  return _jsx(StyledRadioGroup, Object.assign({
    horizontal: direction === 'horizontal',
    className: "radio-group ".concat(className)
  }, rest, {
    children: children
  }), void 0);
}

export default CheckboxGroup;